const AVAILABLE_LANGUAGES = [
  'ru',
  'en',
  // 'zh',
  'pt',
  'es',
  // 'my',
  'pl',
  'vi',
];

module.exports = AVAILABLE_LANGUAGES;
